import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

const ModernHeadingContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isPrivate',
})(({ theme, isPrivate }) => ({
  marginBottom: '20px',
  marginTop: isPrivate ? '0px' : '0px',
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  paddingBottom: '12px',
  borderBottom: isPrivate 
    ? '2px dashed rgba(156, 163, 175, 0.4)' 
    : '2px solid rgba(139, 92, 246, 0.2)',
}))

const ModernSectionHeading = ({ children, isPrivate = false, icon: Icon }) => {
  return (
    <ModernHeadingContainer isPrivate={isPrivate}>
      {Icon && (
        <Box
          sx={{
            width: '28px',
            height: '28px',
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: isPrivate 
              ? 'linear-gradient(135deg, rgba(156, 163, 175, 0.15) 0%, rgba(107, 114, 128, 0.15) 100%)'
              : 'linear-gradient(135deg, rgba(139, 92, 246, 0.15) 0%, rgba(124, 58, 237, 0.15) 100%)',
            color: isPrivate ? '#6b7280' : '#7c3aed',
          }}
        >
          <Icon sx={{ fontSize: 16 }} />
        </Box>
      )}
      <Typography
        component="div"
        sx={{
          fontSize: '18px',
          fontWeight: 700,
          color: isPrivate ? '#6b7280' : '#6b21a8', // Purple text color
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          letterSpacing: '-0.01em',
          textDecoration: 'none',
        }}
      >
        {children}
        {isPrivate && (
          <Typography
            component="span"
            sx={{
              fontSize: '12px',
              fontWeight: 500,
              color: '#9ca3af',
              marginLeft: '8px',
              fontStyle: 'italic',
            }}
          >
            (Private - Not part of therapy report)
          </Typography>
        )}
      </Typography>
    </ModernHeadingContainer>
  )
}

export default ModernSectionHeading

